import React from "react";
import useHasSubscription from "../hooks/useHasSubscription";
import SUBSCRIPTION_RULES from "../consts/SUBSCRIPTION_RULES";

const env = {
  vendorUuid: "a9ee763f-e6db-43cb-81a4-26e4bd0a573e",
  resetPasswordRedirectUri: "https://leanwithlilly.com/reset-password/?code=",
};

export const PHYSIO_COURSE_PRODUCT_ID = 3219;
export const LEARN_EXERCISES_COURSE_PRODUCT_ID = 3220; // also so known as the paid how-to's
export const NUTRITION_COURSE_PRODUCT_ID = 3221;
export const FREE_BANDS_EDUCATION_COURSE_PRODUCT_ID = 3222;
export const CHALLENGES_PRODUCT_ID = 9015;

const GUIDE_MAP = {
  3: {
    booty: 3095,
    sabri: 3389,
    hourglass: 3232,
    smallerWaistGuide: 3100,
    janGuide: 4151,
    strongGuide: 4189,
    week4: 4237,
    leanAndStrongTransformationVol14Weeks: 4531,
    galentine: 4273,
    turnItUp: 4280,
    transformationV2_week2: 4313,
    leanAndStrongTransformationVol24Weeks: 4536,
    // maryBraunWeek1: 4457,
    // maryBraunWeek2: 4474,
    deloadPilatesBootCamp: 4437,
    preSummerBootcamp: 4469,
    // maryBraunWeek3: 4525,
    // maryBraunWeek4: 4530,
    periodFriendly: 4570,
    feelGoodSummer4Weeks: 4681,
    bestOfSculpt: 4652,
    bestOfShred: 4658,
    birthday:4695,
    vacayGuide4Weeks: 4842,
    greensAndGlow4Weeks: 4884,
    twentyOneVol24Weeks: 4995,
    gimmeGummyMore: 4924,
    feelGoodFitFactory4Weeks: 5141,
    halloLeanPrep: 5122,
    halloLeanHellWeek22: 5131,
    bestOfStrength:5156,
    pilatesBody: 5191,
    busyGirlBlackFriday4Weeks: 5337,
    cardioGlowUp: 5276,
    cardioGlowUp4Weeks: 5351,
    leanAndPowerful: 5285,
    leanMass2022Repacked: 5478,
    bestOfSculptMonth: 5358,
    leanTransformationMethodPhase1: 5517,
    leanTransformationMethodPhase2: 5612,
    recoverAndStrengthenPilates: 5633,
    winterGlowUp: 5690,
    lowerBody: 5698,
    upperBodyAndAbsShred: 5717,
    sculptBurnAndShape: 5743,
    ohhiit:5770,
    hourglassSculptAndStrengthen: 5788,
    ultimateWeekOfBattles: 5807,
    powerPilates: 5823,
    leanSummerMethodPhase1: 5889,
    leanSummerMethodPhase2: 5981,
    leanSecondBirthdayBash: 6052,
    twentyOneVol3: 6161,
    fatBurnCoreGalore: 6181,
    legsSculptAndFatBurn: 6277,
    yourStrongestSelf: 6296,
    shapeBurnPilates: 6305,
    shredWithWeights: 6337,
    hourGlassShredShape: 6354,
    absAndUpperBody: 6363,
    leanEmpoweredMethodPhase1: 6380,
    leanEmpoweredMethodPhase2: 6617,
    halloleanHellWeek: 6627,
    pilatesBootcampChallenge: 6808,
    twentyFiveDaysOfLEANMass: 6835,
    setYourNewYearGoals: 6882,
    newYearPrep: 6887,
    pilatesEvolutionPhase1: 7124,
    pilatesEvolutionWeek1: 6924,
    pilatesEvolutionWeek2: 7029,
    pilatesEvolutionWeek3: 7129,
    pilatesEvolutionWeek4: 7151,
    pilatesEvolutionPhase2: 7213,
    pilatesEvolutionWeek5: 7172,
    pilatesEvolutionWeek6: 7189,
    pilatesEvolutionWeek7: 7194,
    pilatesEvolutionDay50: 7202,
    pilatesEvolutionWeek9: 7207,
    bestOfLmpe: 7278,
    weekOfWellness: 7272,
    matInspiredReformerPilates: 7292,
    ultimateStrengthChallenge: 7304,
    pilatesStrengthFusion: 7345,
    lowImpactFatBurn: 7431,
    sunsOutBunsOut: 7441,
    powerUpPilatesWeek3: 7519,
    summerSurprisePrep: 7538,
    summerSurprisePrepw1: 7496,
    pilatesSummerSculptPhase1: 7554,
    pilatesSummerSculptPhase2: 7649,
    leanLifestyle: 7740,
    coreStrengthStability: 7770,
    buildStrengthMonthWeek4: 7872,
    resetAndThriveChallenge: 7894,
    buildYourStengthMonth: 7923,
    bestOfLeanMethod: 7911,
    ultimateStrengthChallenge2: 8002,
    halloLeanHellWeek24: 8015,
    twentyOneVol4: 8102,
    bestOfSculptWeek1: 8039,
    bestOfSculptStrength: 8189,
    winterGlowUp2: 8205,
    newYearGoals: 8231,
    levelUpPrep: 8281,
    leanMethodLevelUp: 8299,
    leanMethodDeloadWeek: 8655,
    toneAndTransform: 8741,
    coreStrengthStability2: 8746,
    sevenDayBootySculpt: 8791,
    defineAndRefine: 8796,
    sweatyBootcamp: 8908,
    summerPrep2025: 8954,
    leanMethodElevateP1: 8985,
    leamMethodLevel5: 9018,    
    leanMethodLevel4: 9022,    
    leanMethodLevel3: 9032,    
    leanMethodLevel2: 9027,
    leanMethodElevateP2: 8990,
    pilatesLowImpactWeek: 9201,
    scultLeanMuscle: 9208,
    buildStrengthPilates: 9213,
    leanAbsAndUpperBody: 9264,
    weightsAndBurn: 9269,
    resetChallenge: 9341,
    powerLegsAndSculpt: 9359,
    wellnessReadyWeek: 9379,
    pilatedFusionBurn: 9364,
    leanSculptAndFlow: 9421,
    strengthAndBalance: 9454,
    transformationPrep: 9533,
    leanMethodTransformation: 9483,
    hourglassSculpt: 9589,
    lowerBodyStrengthSculpt: 9637,
    reformerInspiredPilates: 9653,
    coreCardioStength: 9662,
    defineChallengePhase: 9688,
    defineChallengePhase2: 9841,
    lean2in1PrepWeek: 9910,
    lean2In1MethodPilatesXStrengthFullGuide: 9914,
    lean7DayBootySculpt2026: 9978,
    leanCoreStrengthAndStability: 10000,
    leanUltimateStrengthWeek: 10019,
    leanAbsAndUpperBody2026: 10027,
    leanSummerSculptChallengePrepWeek: 10049,
    leanSummerSculptChallengeFullGuide: 10054,
    leanLowerBodyStrengthandCardioWeek: 10190,
    lean2In1AbsAndSculptFullGuide: 10211,
    lean2In1AbsAndSculptWeek1: 10215,
    lean2in1AbsAndSculptFullLengthGuide: 10211,
    leanSummerSeriesArms: 10273,
    leanSummerSeriesLowerBody: 10290,
    leanSummerSeriesQuickBurn: 10295,
    leanSummerSeriesAbs: 10300,
    leanSummerSeriesGlutes2: 10315,
    summerSeriesUpperBody: 10320,
    leanChallengePrepWeekGuide: 10358,
    reDefineBeginner: 10373,
    redefineIntermediateandAdvanced: 10353,
    redefineIntermediateandAdvancedFullLength: 10369,
    redefineIntermediateWeek2: 10384,
    redefineWeek3: 10389,
    redefineWeek4: 10402,
    redefineWeek5: 10408,
    redefineWeek6: 10413,
    deloadWeek2026: 10440,
  },
  4: {
    booty: 3094,
    sabri: 3388,
    hourglass: 3233,
    smallerWaistGuide: 3099,
    twentyOne: 3472,
    cutGuide: 3670,
    strongCapable: 4100,
    janGuide: 4150,
    strongGuide: 4188,
    week4: 4236,
    leanAndStrongTransformationVol14Weeks: 4532,
    galentine: 4272,
    turnItUp: 4279,
    transformationV2_week2: 4312,
    leanAndStrongTransformationVol24Weeks: 4537,
    // maryBraunWeek1: 4456,
    // maryBraunWeek2: 4473,
    deloadPilatesBootCamp: 4438,
    preSummerBootcamp: 4468,
    // maryBraunWeek3: 4524,
    // maryBraunWeek4: 4529,
    periodFriendly: 4570,
    feelGoodSummer4Weeks: 4680,
    bestOfSculpt: 4651,
    bestOfShred: 4659,
    birthday:4696,
    vacayGuide4Weeks: 4843,
    greensAndGlow4Weeks: 4883,
    twentyOneVol24Weeks: 4994,
    gimmeGummyMore: 4923,
    feelGoodFitFactory4Weeks: 5140,
    halloLeanPrep: 5123,
    halloLeanHellWeek22: 5132,
    bestOfStrength: 5157,
    pilatesBody: 5192,
    busyGirlBlackFriday4Weeks: 5338,
    cardioGlowUp: 5277,
    cardioGlowUp4Weeks: 5350,
    leanAndPowerful: 5286,
    leanMass2022Repacked: 5477,
    bestOfSculptMonth: 5357,
    leanTransformationMethodPhase1: 5516,
    leanTransformationMethodPhase2: 5611,
    recoverAndStrengthenPilates: 5632,
    winterGlowUp: 5689,
    lowerBody: 5697,
    upperBodyAndAbsShred: 5716,
    sculptBurnAndShape: 5742,
    ohhiit:5769,
    hourglassSculptAndStrengthen: 5787,
    ultimateWeekOfBattles: 5808,
    powerPilates: 5822,
    leanSummerMethodPhase1: 5888,
    leanSummerMethodPhase2: 5982,
    leanSecondBirthdayBash: 6051,
    twentyOneVol3: 6160,
    fatBurnCoreGalore: 6180,
    legsSculptAndFatBurn: 6276,
    yourStrongestSelf: 6295,
    shapeBurnPilates: 6304,
    shredWithWeights: 6338,
    hourGlassShredShape: 6355,
    absAndUpperBody: 6364,
    leanEmpoweredMethodPhase1: 6379,
    leanEmpoweredMethodPhase2: 6616,
    halloLeanHellWeek: 6626,
    pilatesBootcampChallenge: 6807,
    twentyFiveDaysOfLEANMass: 6834,
    setYourNewYearGoals: 6881,
    newYearPrep: 6886,
    pilatesEvolutionPhase1: 7123,
    pilatesEvolutionWeek1: 6923,
    pilatesEvolutionWeek2: 7028,
    pilatesEvolutionWeek3: 7128,
    pilatesEvolutionWeek4: 7150,
    pilatesEvolutionPhase2: 7212,
    pilatesEvolutionWeek5: 7171,
    pilatesEvolutionWeek6: 7188,
    pilatesEvolutionWeek7: 7193,
    pilatesEvolutionDay50: 7201,
    pilatesEvolutionWeek9: 7206,
    bestOfLmpe: 7277,
    weekOfWellness: 7271,
    matInspiredReformerPilates: 7291,
    ultimateStrengthChallenge: 7303,
    pilatesStrengthFusion: 7346,
    lowImpactFatBurn: 7430,
    sunsOutBunsOut: 7440,
    powerUpPilatesWeek3: 7518,
    summerSurprisePrep: 7537,
    summerSurprisePrepw1: 7495,
    pilatesSummerSculptPhase1: 7553,
    pilatesSummerSculptPhase2: 7648,
    leanLifestyle: 7739,
    coreStrengthStability: 7769,
    buildStrengthMonthWeek4: 7873,
    resetAndThriveChallenge: 7895,
    buildYourStengthMonth: 7922,
    bestOfLeanMethod: 7910,
    ultimateStrengthChallenge2: 8001,
    halloLeanHellWeek24: 8016,
    twentyOneVol4: 8095,
    bestOfSculptWeek1: 8038,
    bestOfSculptStrength: 8190,
    winterGlowUp2: 8206,
    newYearGoals: 8230,
    levelUpPrep: 8280,
    leanMethodLevelUp: 8298,
    leanMethodDeloadWeek: 8654,
    toneAndTransform: 8742,
    coreStrengthStability2: 8747,
    sevenDayBootySculpt: 8790,
    defineAndRefine: 8795,
    sweatyBootcamp: 8907,
    summerPrep2025: 8952,
    leanMethodElevateP1: 8984,    
    leamMethodLevel5: 9017,    
    leanMethodLevel4: 9021,    
    leanMethodLevel3: 9031,    
    leanMethodLevel2: 9026,
    leanMethodElevateP2: 8989,
    pilatesLowImpactWeek: 9200,
    scultLeanMuscle: 9207,
    buildStrengthPilates: 9212,
    leanAbsAndUpperBody: 9263,
    weightsAndBurn: 9268,
    resetChallenge: 9340,
    powerLegsAndSculpt: 9358,
    wellnessReadyWeek: 9378,
    pilatedFusionBurn: 9363,
    leanSculptAndFlow: 9420,
    strengthAndBalance: 9453,
    transformationPrep: 9532,
    leanMethodTransformation: 9482,
    hourglassSculpt: 9588,
    lowerBodyStrengthSculpt: 9636,
    reformerInspiredPilates: 9652,
    coreCardioStength: 9661,
    defineChallengePhase: 9687,
    defineChallengePhase2: 9840,
    lean2in1PrepWeek: 9909,
    lean2In1MethodPilatesXStrengthFullGuide: 9913,
    lean7DayBootySculpt2026: 9977,
    leanCoreStrengthAndStability: 9999,
    leanUltimateStrengthWeek: 10018,
    leanAbsAndUpperBody2026: 10026,
    leanSummerSculptChallengePrepWeek: 10048,
    leanSummerSculptChallengeFullGuide: 10053,
    leanLowerBodyStrengthandCardioWeek: 10189,
    lean2In1AbsAndSculptFullGuide: 10210,
    lean2In1AbsAndSculptWeek1: 10214,
    lean2in1AbsAndSculptFullLengthGuide: 10210,
    leanSummerSeriesArms: 10272,
    leanSummerSeriesLowerBody: 10289,
    leanSummerSeriesQuickBurn: 10294,
    leanSummerSeriesAbs: 10299,
    leanSummerSeriesGlutes2: 10314,
    summerSeriesUpperBody: 10319,
    leanChallengePrepWeekGuide: 10357,
    reDefineBeginner: 10372,
    redefineIntermediateandAdvanced: 10352,
    redefineIntermediateandAdvancedFullLength: 10368,
    redefineIntermediateWeek2: 10383,
    redefineWeek3: 10388,
    redefineWeek4: 10401,
    redefineWeek5: 10407,
    redefineWeek6: 10412,
    deloadWeek2026: 10439,
  },
  5: {
    booty: 3093,
    sabri: 3387,
    hourglass: 3234,
    smallerWaistGuide: 3098,
    twentyOne: 3471,
    cutGuide: 3669,
    strongCapable: 4099,
    janGuide: 4149,
    strongGuide: 4151,
    week4: 4235,
    leanAndStrongTransformationVol14Weeks: 4533,
    galentine: 4271,
    turnItUp: 4278,
    transformationV2_week2: 4311,
    leanAndStrongTransformationVol24Weeks: 4538,
    // maryBraunWeek1: 4455,
    // maryBraunWeek2: 4472,
    deloadPilatesBootCamp: 4442,
    preSummerBootcamp: 4467,
    // maryBraunWeek3: 4523,
    // maryBraunWeek4: 4528,
    periodFriendly: 4570,
    feelGoodSummer4Weeks: 4679,
    bestOfSculpt: 4650,
    bestOfShred: 4660,
    birthday:4697,
    vacayGuide4Weeks: 4844,
    greensAndGlow4Weeks: 4882,
    twentyOneVol24Weeks: 4993,
    gimmeGummyMore: 4922,
    feelGoodFitFactory4Weeks: 5139,
    halloLeanPrep: 5124,
    halloLeanHellWeek22: 5133,
    bestOfStrength: 5158,
    pilatesBody: 5193,
    busyGirlBlackFriday4Weeks: 5339,
    cardioGlowUp: 5278,
    cardioGlowUp4Weeks: 5349,
    leanAndPowerful: 5287,
    leanMass2022Repacked: 5476,
    bestOfSculptMonth: 5356,
    leanTransformationMethodPhase1: 5515,
    leanTransformationMethodPhase2: 5610,
    recoverAndStrengthenPilates: 5631,
    winterGlowUp: 5688,
    lowerBody: 5696,
    upperBodyAndAbsShred: 5715,
    sculptBurnAndShape: 5741,
    ohhiit:5768,
    hourglassSculptAndStrengthen: 5786,
    ultimateWeekOfBattles: 5809,
    powerPilates: 5821,
    leanSummerMethodPhase1: 5887,
    leanSummerMethodPhase2: 5983,
    leanSecondBirthdayBash: 6050,
    twentyOneVol3: 6159,
    fatBurnCoreGalore: 6179,
    legsSculptAndFatBurn: 6275,
    yourStrongestSelf: 6294,
    shapeBurnPilates: 6303,
    shredWithWeights: 6339,
    hourGlassShredShape: 6356,
    absAndUpperBody: 6365,
    leanEmpoweredMethodPhase1: 6378,
    leanEmpoweredMethodPhase2: 6615,
    halloLeanHellWeek: 6625,
    pilatesBootcampChallenge: 6806,
    twentyFiveDaysOfLEANMass: 6833,
    setYourNewYearGoals: 6880,
    newYearPrep: 6885,
    pilatesEvolutionPhase1: 7122,
    pilatesEvolutionWeek1: 6922,
    pilatesEvolutionWeek2: 7027,
    pilatesEvolutionWeek3: 7127,
    pilatesEvolutionWeek4: 7149,
    pilatesEvolutionPhase2: 7211,
    pilatesEvolutionWeek5: 7170,
    pilatesEvolutionWeek6: 7187,
    pilatesEvolutionWeek7: 7192,
    pilatesEvolutionDay50: 7200,
    pilatesEvolutionWeek9: 7205,
    bestOfLmpe: 7276,
    weekOfWellness: 7270,
    matInspiredReformerPilates: 7290,
    ultimateStrengthChallenge: 7302,
    pilatesStrengthFusion: 7347,
    lowImpactFatBurn: 7429,
    sunsOutBunsOut: 7439,
    powerUpPilatesWeek3: 7517,
    summerSurprisePrep: 7536,
    summerSurprisePrepw1: 7494,
    pilatesSummerSculptPhase1: 7552,
    pilatesSummerSculptPhase2: 7647,
    leanLifestyle: 7738,
    coreStrengthStability: 7768,
    buildStrengthMonthWeek4: 7874,
    resetAndThriveChallenge: 7896,
    buildYourStengthMonth: 7921,
    bestOfLeanMethod: 7909,
    ultimateStrengthChallenge2: 8000,
    halloLeanHellWeek24: 8017,
    twentyOneVol4: 8101,
    bestOfSculptWeek1: 8037,
    bestOfSculptStrength: 8191,
    winterGlowUp2: 8207,
    newYearGoals: 8229,
    levelUpPrep: 8279,
    leanMethodLevelUp: 8297,
    leanMethodDeloadWeek: 8653,
    toneAndTransform: 8743,
    coreStrengthStability2: 8748,
    sevenDayBootySculpt: 8789,
    defineAndRefine: 8794,
    sweatyBootcamp: 8906,
    summerPrep2025: 8951,
    leanMethodElevateP1: 8983,    
    leamMethodLevel5: 9016,    
    leanMethodLevel4: 9020,    
    leanMethodLevel3: 9030,    
    leanMethodLevel2: 9025,
    leanMethodElevateP2: 8988,
    pilatesLowImpactWeek: 9199,
    scultLeanMuscle: 9205,
    buildStrengthPilates: 9211,
    leanAbsAndUpperBody: 9262,
    weightsAndBurn: 9267,
    resetChallenge: 9339,
    powerLegsAndSculpt: 9357,
    wellnessReadyWeek: 9377,
    pilatedFusionBurn: 9362,
    leanSculptAndFlow: 9419,
    strengthAndBalance: 9452,
    transformationPrep: 9531,
    leanMethodTransformation: 9481,
    hourglassSculpt: 9587,
    lowerBodyStrengthSculpt: 9635,
    reformerInspiredPilates: 9651,
    coreCardioStength: 9660,
    defineChallengePhase: 9686,
    defineChallengePhase2: 9839,
    lean2in1PrepWeek: 9908,
    lean2In1MethodPilatesXStrengthFullGuide: 9912,
    lean7DayBootySculpt2026: 9976,
    leanCoreStrengthAndStability: 9998,
    leanUltimateStrengthWeek: 10017,
    leanAbsAndUpperBody2026: 10025,
    leanSummerSculptChallengePrepWeek: 10047,
    leanSummerSculptChallengeFullGuide: 10052,
    leanLowerBodyStrengthandCardioWeek: 10188,
    lean2In1AbsAndSculptFullGuide: 10209,
    lean2In1AbsAndSculptWeek1: 10213,
    lean2in1AbsAndSculptFullLengthGuide: 10209,
    leanSummerSeriesArms: 10271,
    leanSummerSeriesLowerBody: 10288,
    leanSummerSeriesQuickBurn: 10293,
    leanSummerSeriesAbs: 10298,
    leanSummerSeriesGlutes2: 10313,
    summerSeriesUpperBody: 10318,
    leanChallengePrepWeekGuide: 10356,
    reDefineBeginner: 10371,
    redefineIntermediateandAdvanced: 10351,
    redefineIntermediateandAdvancedFullLength: 10367,
    redefineIntermediateWeek2: 10382,
    redefineWeek3: 10387,
    redefineWeek4: 10400,
    redefineWeek5: 10406,
    redefineWeek6: 10411,
    deloadWeek2026: 10438,
  },
  6: {
    booty: 3092,
    sabri: 3386,
    hourglass: 3235,
    smallerWaistGuide: 3097,
    twentyOne: 3470,
    cutGuide: 3668,
    strongCapable: 4098,
    pilates: 4141,
    janGuide: 4148,
    strongGuide: 4150,
    week4: 4234,
    leanAndStrongTransformationVol14Weeks: 4534,
    galentine: 4270,
    turnItUp: 4277,
    transformationV2_week2: 4310,
    leanAndStrongTransformationVol24Weeks: 4539,
    // maryBraunWeek1: 4454,
    // maryBraunWeek2: 4471,
    deloadPilatesBootCamp: 4443,
    preSummerBootcamp: 4466,
    // maryBraunWeek3: 4522,
    // maryBraunWeek4: 4527,
    periodFriendly: 4570,
    feelGoodSummer4Weeks: 4678,
    bestOfSculpt: 4649,
    bestOfShred: 4661,
    birthday:4698,
    vacayGuide4Weeks: 4845,
    greensAndGlow4Weeks: 4881,
    twentyOneVol24Weeks: 4992,
    gimmeGummyMore: 4921,
    feelGoodFitFactory4Weeks: 5138,
    halloLeanPrep: 5125,
    halloLeanHellWeek22: 5134,
    bestOfStrength: 5159,
    pilatesBody: 5194,
    busyGirlBlackFriday4Weeks: 5340,
    cardioGlowUp: 5279,
    cardioGlowUp4Weeks: 5348,
    leanAndPowerful: 5288,
    leanMass2022Repacked: 5475,
    bestOfSculptMonth: 5355,
    leanTransformationMethodPhase1: 5514,
    leanTransformationMethodPhase2: 5609,
    recoverAndStrengthenPilates: 5630,
    winterGlowUp: 5687,
    lowerBody: 5695,
    upperBodyAndAbsShred: 5714,
    sculptBurnAndShape: 5740,
    ohhiit:5767,
    hourglassSculptAndStrengthen: 5785,
    ultimateWeekOfBattles: 5810,
    powerPilates: 5820,
    leanSummerMethodPhase1: 5886,
    leanSummerMethodPhase2: 5984,
    leanSecondBirthdayBash: 6049,
    twentyOneVol3: 6158,
    fatBurnCoreGalore: 6178,
    fatBurnCoreGaloreWeek1: 6274,
    yourStrongestSelf: 6293,
    shapeBurnPilates: 6302,
    shredWithWeights: 6340,
    hourGlassShredShape: 6357,
    absAndUpperBody: 6366,
    leanEmpoweredMethodPhase1: 6377,
    leanEmpoweredMethodPhase2: 6614,
    halloLeanHellWeek: 6624,
    pilatesBootcampChallenge: 6805,
    twentyFiveDaysOfLEANMass: 6832,
    setYourNewYearGoals: 6879,
    newYearPrep: 6884,
    pilatesEvolutionPhase1: 7121,
    pilatesEvolutionWeek1: 6921,
    pilatesEvolutionWeek2: 7026,
    pilatesEvolutionWeek3: 7126,
    pilatesEvolutionWeek4: 7148,
    pilatesEvolutionPhase2: 7210,
    pilatesEvolutionWeek5: 7169,
    pilatesEvolutionWeek6: 7186,
    pilatesEvolutionWeek7: 7191,
    pilatesEvolutionDay50: 7199,
    pilatesEvolutionWeek9: 7204,
    bestOfLmpe: 7275,
    weekOfWellness: 7269,
    matInspiredReformerPilates: 7289,
    ultimateStrengthChallenge: 7301,
    pilatesStrengthFusion: 7348,
    lowImpactFatBurn: 7428,
    sunsOutBunsOut: 7438,
    powerUpPilatesWeek3: 7516,
    summerSurprisePrep: 7535,
    summerSurprisePrepw1: 7493,
    pilatesSummerSculptPhase1: 7551,
    pilatesSummerSculptPhase2: 7646,
    leanLifestyle: 7737,
    coreStrengthStability: 7767,
    buildStrengthMonthWeek4: 7875,
    resetAndThriveChallenge: 7897,
    buildYourStengthMonth: 7920,
    bestOfLeanMethod: 7908,
    ultimateStrengthChallenge2: 7999,
    halloLeanHellWeek24: 8018,
    twentyOneVol4: 8103,
    bestOfSculptWeek1: 8036,
    bestOfSculptStrength: 8192,
    winterGlowUp2: 8208,
    newYearGoals: 8228,
    levelUpPrep: 8278,
    leanMethodLevelUp: 8296,
    leanMethodDeloadWeek: 8652,
    toneAndTransform: 8744,
    coreStrengthStability2: 8749,
    sevenDayBootySculpt: 8788,
    defineAndRefine: 8793,
    sweatyBootcamp: 8905,
    summerPrep2025: 8950,
    leanMethodElevateP1: 8981,    
    leamMethodLevel5: 9014,    
    leanMethodLevel4: 9019,    
    leanMethodLevel3: 9029,    
    leanMethodLevel2: 9024,
    leanMethodElevateP2: 8987,
    pilatesLowImpactWeek: 9198,
    scultLeanMuscle: 9204,
    buildStrengthPilates: 9210,
    leanAbsAndUpperBody: 9261,
    weightsAndBurn: 9266,
    resetChallenge: 9338,
    powerLegsAndSculpt: 9356,
    wellnessReadyWeek: 9376,
    pilatedFusionBurn: 9361,
    leanSculptAndFlow: 9418,
    strengthAndBalance: 9451,
    transformationPrep: 9530,
    leanMethodTransformation: 9480,
    hourglassSculpt: 9586,
    lowerBodyStrengthSculpt: 9634,
    reformerInspiredPilates: 9644,
    coreCardioStength: 9659,
    defineChallengePhase: 9685,
    defineChallengePhase2: 9838,
    lean2in1PrepWeek: 9907,
    lean2In1MethodPilatesXStrengthFullGuide: 9911,
    lean7DayBootySculpt2026: 9975,
    leanCoreStrengthAndStability: 9997,
    leanUltimateStrengthWeek: 10016,
    leanAbsAndUpperBody2026: 10024,
    leanSummerSculptChallengePrepWeek: 10046,
    leanSummerSculptChallengeFullGuide: 10051,
    leanLowerBodyStrengthandCardioWeek: 10187,
    lean2In1AbsAndSculptFullGuide: 10208,
    lean2In1AbsAndSculptWeek1: 10212,
    lean2in1AbsAndSculptFullLengthGuide: 10208,
    leanSummerSeriesArms: 10270,
    leanSummerSeriesLowerBody: 10287,
    leanSummerSeriesQuickBurn: 10292,
    leanSummerSeriesAbs: 10297,
    leanSummerSeriesGlutes2: 10312,
    summerSeriesUpperBody: 10317,
    leanChallengePrepWeekGuide: 10355,
    reDefineBeginner: 10370,
    redefineIntermediateandAdvanced: 10350,
    redefineIntermediateandAdvancedFullLength: 10366,
    redefineIntermediateWeek2: 10381,
    redefineWeek3: 10386,
    redefineWeek4: 10399,
    redefineWeek5: 10405,
    redefineWeek6: 10410,
    deloadWeek2026: 10437,
  },
  7: {
    twentyOne: 3469,
    halloLean: 3484,
    cutGuide: 3667,
    leanMas: 4115,
    week4: 4233,
    leanAndStrongTransformationVol14Weeks: 4535,
    galentine: 4269,
    turnItUp: 4276,
    transformationV2_week2: 4309,
    leanAndStrongTransformationVol24Weeks: 4540,
    // maryBraunWeek1: 4453,
    // maryBraunWeek2: 4470,
    deloadPilatesBootCamp: 4444,
    preSummerBootcamp: 4465,
    // maryBraunWeek3: 4521,
    // maryBraunWeek4: 4526,
    periodFriendly: 4570,
    feelGoodSummer4Weeks: 4677,
    bestOfSculpt: 4648,
    bestOfShred: 4662,
    birthday:4699,
    vacayGuide4Weeks: 4846,
    greensAndGlow4Weeks: 4880,
    twentyOneVol24Weeks: 4991,
    gimmeGummyMore: 4920,
    feelGoodFitFactory4Weeks: 5137,
    halloLeanPrep: 5126,
    halloLeanHellWeek22: 5135,
    bestOfStrength: 5160,
    pilatesBody: 5195,
    busyGirlBlackFriday4Weeks: 5341,
    cardioGlowUp: 5280,
    cardioGlowUp4Weeks: 5342,
    leanAndPowerful: 5289,
    leanMass2022Repacked: 5474,
    bestOfSculptMonth: 5354,
    leanTransformationMethodPhase1: 5513,
    leanTransformationMethodPhase2: 5608,
    recoverAndStrengthenPilates: 5629,
    winterGlowUp: 5681,
    lowerBody: 5694,
    upperBodyAndAbsShred: 5713,
    sculptBurnAndShape: 5739,
    ohhiit:5766,
    hourglassSculptAndStrengthen: 5784,
    ultimateWeekOfBattles: 5811,
    powerPilates: 5819,
    leanSummerMethodPhase1: 5885,
    leanSummerMethodPhase2: 5985,
    leanSecondBirthdayBash: 6044,
    twentyOneVol3: 6157,
    fatBurnCoreGalore: 6177,
    fatBurnCoreGaloreWeek1: 6273,
    yourStrongestSelf: 6292,
    shapeBurnPilates: 6301,
    shredWithWeights: 6341,
    hourGlassShredShape: 6358,
    absAndUpperBody: 6367,
    leanEmpoweredMethodPhase1: 6368,
    leanEmpoweredMethodPhase2: 6613,
    halloLeanHellWeek: 6623,
    pilatesBootcampChallenge: 6804,
    twentyFiveDaysOfLEANMass: 6831,
    setYourNewYearGoals: 6877,
    newYearPrep: 6883,
    pilatesEvolutionPhase1: 7120,
    pilatesEvolutionWeek1: 6920,
    pilatesEvolutionWeek2: 7014,
    pilatesEvolutionWeek3: 7125,
    pilatesEvolutionWeek4: 7147,
    pilatesEvolutionPhase2: 7209,
    pilatesEvolutionWeek5: 7168,
    pilatesEvolutionWeek6: 7185,
    pilatesEvolutionWeek7: 7190,
    pilatesEvolutionDay50: 7198,
    pilatesEvolutionWeek9: 7203,
    bestOfLmpe: 7274,
    weekOfWellness: 7268,
    matInspiredReformerPilates: 7279,
    ultimateStrengthChallenge: 7300,
    pilatesStrengthFusion: 7349,
    lowImpactFatBurn: 7427,
    sunsOutBunsOut: 7437,
    powerUpPilatesWeek3: 7515,
    summerSurprisePrep: 7534,
    summerSurprisePrepw1: 7492,
    pilatesSummerSculptPhase1: 7550,
    pilatesSummerSculptPhase2: 7645,
    leanLifestyle: 7736,
    coreStrengthStability: 7766,
    buildStrengthMonthWeek4: 7876,
    resetAndThriveChallenge: 7898,
    buildYourStengthMonth: 7919,
    bestOfLeanMethod: 7902,
    ultimateStrengthChallenge2: 7998,
    halloLeanHellWeek24: 8019,
    twentyOneVol4: 8104,
    bestOfSculptWeek1: 8035,
    bestOfSculptStrength: 8193,
    winterGlowUp2: 8209,
    newYearGoals: 8227,
    levelUpPrep: 8277,
    leanMethodLevelUp: 8292,
    leanMethodDeloadWeek: 8651,
    toneAndTransform: 8745,
    coreStrengthStability2: 8750,
    sevenDayBootySculpt: 8787,
    defineAndRefine: 8792,
    sweatyBootcamp: 8904,
    summerPrep2025: 8949,
    leanMethodElevateP1: 8982,    
    leamMethodLevel5: 9034,    
    leanMethodLevel4: 9035,    
    leanMethodLevel3: 9028,    
    leanMethodLevel2: 9023,
    leanMethodElevateP2: 8986,
    pilatesLowImpactWeek: 9197,
    scultLeanMuscle: 9202,
    buildStrengthPilates: 9209,
    leanAbsAndUpperBody: 9260,
    weightsAndBurn: 9265,
    resetChallenge: 9307,
    powerLegsAndSculpt: 9350,
    wellnessReadyWeek: 9375,
    pilatedFusionBurn: 9360,
    leanSculptAndFlow: 9417,
    strengthAndBalance: 9450,
    transformationPrep: 9462,
    leanMethodTransformation: 9479,
    hourglassSculpt: 9585,
    lowerBodyStrengthSculpt: 9633,
    reformerInspiredPilates: 9650,
    coreCardioStength: 9654,
    defineChallengePhase: 9684,
    defineChallengePhase2: 9821,
    lean2in1PrepWeek: 9906,
    lean2In1MethodPilatesXStrengthFullGuide: 9905,
    lean7DayBootySculpt2026: 9974,
    leanCoreStrengthAndStability: 9996,
    leanUltimateStrengthWeek: 10015,
    leanAbsAndUpperBody2026: 10021,
    leanSummerSculptChallengePrepWeek: 10045,
    leanSummerSculptChallengeFullGuide: 10050,
    leanLowerBodyStrengthandCardioWeek: 10181,
    lean2In1AbsAndSculptFullGuide: 10191,
    lean2In1AbsAndSculptWeek1: 10192,
    lean2in1AbsAndSculptFullLengthGuide: 10191,
    leanSummerSeriesArms: 10269,
    leanSummerSeriesLowerBody: 10286,
    leanSummerSeriesQuickBurn: 10291,
    leanSummerSeriesAbs: 10296,
    leanSummerSeriesGlutes2: 10311,
    summerSeriesUpperBody: 10316,
    leanChallengePrepWeekGuide: 10354,
    reDefineBeginner: 10335,
    redefineIntermediateandAdvanced: 10349,
    redefineIntermediateandAdvancedFullLength: 10334,
    redefineIntermediateWeek2: 10380,
    redefineWeek3: 10385,
    redefineWeek4: 10398,
    redefineWeek5: 10404,
    redefineWeek6: 10409,
    deloadWeek2026: 10436,
  },
};

export const GUIDE_FIND_WORKOUT_FREQUENCY = (productID) =>
  Object?.keys(GUIDE_MAP)?.find((key) => Object?.values(GUIDE_MAP?.[key])?.indexOf(productID) > -1);

export const GUIDES_ORDER = [];
// [
//     GUIDE_MAP?.['3']?.smallerWaistGuide,
//     GUIDE_MAP?.['4']?.smallerWaistGuide,
//     GUIDE_MAP?.['5']?.smallerWaistGuide,
//     GUIDE_MAP?.['6']?.smallerWaistGuide,
//     GUIDE_MAP?.['3']?.booty,
//     GUIDE_MAP?.['4']?.booty,
//     GUIDE_MAP?.['5']?.booty,
//     GUIDE_MAP?.['6']?.booty,
//     GUIDE_MAP?.['3']?.hourglass,
//     GUIDE_MAP?.['4']?.hourglass,
//     GUIDE_MAP?.['5']?.hourglass,
//     GUIDE_MAP?.['6']?.hourglass,
// ];

// export const staging = {
//   aws: {
//     url: "https://rm56uphfwjfrnfe2msn3a6g6bi.appsync-api.eu-west-1.amazonaws.com/graphql",
//     region: "eu-west-1",
//     type: "AWS_IAM",
//   },
//   cognito: {
//     identityPoolId: "eu-west-1:4936b8f4-66cd-4175-84e5-7a983eb47180",
//     region: "eu-west-1",
//     userPoolId: "eu-west-1_3sxDScGLH",
//     userPoolWebClientId: "4jgkebm1mh2v2r8vq05f4q21b3",
//     mandatorySignIn: "false",
//   },
//   forgotPassword: "https://jhhs6d8jmb.execute-api.eu-west-1.amazonaws.com/dev",
//   verificationsBaseURL: "https://verifications.staging.genflow.com",
// };
export const staging = {
  aws: {
    url: "https://uyuh4pjnwnd3fdltnovspiihwu.appsync-api.eu-west-1.amazonaws.com/graphql",
    region: "eu-west-1",
    type: "AWS_IAM",
  },
  cognito: {
    identityPoolId: "eu-west-1:8429ef9e-4f57-45f6-8354-4ec9b80a5fb9",
    region: "eu-west-1",
    userPoolId: "eu-west-1_lVdmqTrRz",
    userPoolWebClientId: "52veqmv4vo352fqmsevpr7vjk3",
    mandatorySignIn: "false",
  },
  forgotPassword: "https://7efpy5nte8.execute-api.eu-west-1.amazonaws.com/prod",
  verificationsBaseURL: "https://verifications.aws.genflow.com",
};
export const production = {
  aws: {
    url: "https://uyuh4pjnwnd3fdltnovspiihwu.appsync-api.eu-west-1.amazonaws.com/graphql",
    region: "eu-west-1",
    type: "AWS_IAM",
  },
  cognito: {
    identityPoolId: "eu-west-1:8429ef9e-4f57-45f6-8354-4ec9b80a5fb9",
    region: "eu-west-1",
    userPoolId: "eu-west-1_lVdmqTrRz",
    userPoolWebClientId: "52veqmv4vo352fqmsevpr7vjk3",
    mandatorySignIn: "false",
  },
  forgotPassword: "https://7efpy5nte8.execute-api.eu-west-1.amazonaws.com/prod",
  verificationsBaseURL: "https://verifications.aws.genflow.com",
};

export const subscription = {
  rules: SUBSCRIPTION_RULES,
  hasSubscription: useHasSubscription,
};

export default {
  ...env,
  production,
  staging,
  subscription,
  GUIDE_MAP,
  GUIDES_ORDER,
  PHYSIO_COURSE_PRODUCT_ID,
  LEARN_EXERCISES_COURSE_PRODUCT_ID,
  NUTRITION_COURSE_PRODUCT_ID,
  FREE_BANDS_EDUCATION_COURSE_PRODUCT_ID,
};
